// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MarketsBase_wrapper_ZfUTF","breadcrumbs":"MarketsBase_breadcrumbs_3dHXt","description":"MarketsBase_description_1uIKJ","markets":"MarketsBase_markets_2JLE_"};